import React from 'react';
import { ToggleProps } from '../../../types';
import './Toggle.css';

const Toggle: React.FC<ToggleProps> = ({
  id,
  label,
  checked,
  onChange,
  description,
  disabled = false,
  className = ''
}) => {
  const toggleClasses = `toggle-container ${className}`.trim();
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };
  
  return (
    <div className={toggleClasses}>
      <label className="toggle-switch">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          className="toggle-input"
        />
        <span className="toggle-slider"></span>
      </label>
      <div className="toggle-content">
        <label htmlFor={id} className="toggle-label">{label}</label>
        {description && <p className="toggle-description">{description}</p>}
      </div>
    </div>
  );
};

export default Toggle;
